import { render, staticRenderFns } from "./IconFigExit.vue?vue&type=template&id=d6640cb4"
import script from "./IconFigExit.vue?vue&type=script&lang=js"
export * from "./IconFigExit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports